import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Sprout } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { to: "/shop", label: "Shop", testid: "nav-link-shop" },
  { to: "/about", label: "About", testid: "nav-link-about" },
  { to: "/faq", label: "FAQ", testid: "nav-link-faq" },
  { to: "/contact", label: "Contact", testid: "nav-link-contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 border-b border-sage/10 bg-cream/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 md:px-8">
        <Link to="/" data-testid="header-logo" aria-label="Bloom Paper Studio home">
          <Logo />
        </Link>
        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors duration-300 hover:text-sage ${
                  isActive ? "text-sage font-medium" : "text-ink/70"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/admin"
            data-testid="header-admin-link"
            className="flex items-center gap-2 rounded-full border border-sage/25 px-4 py-2 text-xs font-medium uppercase tracking-[0.15em] text-sage transition-all duration-300 hover:-translate-y-0.5 hover:bg-sage hover:text-cream"
          >
            <Sprout size={14} /> Owner Studio
          </Link>
        </nav>
        <button
          data-testid="mobile-menu-button"
          className="text-ink md:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden border-t border-sage/10 bg-cream md:hidden"
          >
            <div className="flex flex-col gap-1 px-6 py-4">
              {LINKS.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  data-testid={`mobile-${l.testid}`}
                  onClick={() => setOpen(false)}
                  className="rounded-lg px-3 py-3 font-serif text-lg text-ink/80 transition-colors hover:bg-sage-tint"
                >
                  {l.label}
                </Link>
              ))}
              <Link
                to="/admin"
                data-testid="mobile-header-admin-link"
                onClick={() => setOpen(false)}
                className="mt-2 flex items-center gap-2 rounded-full border border-sage/25 px-4 py-3 text-xs font-medium uppercase tracking-[0.15em] text-sage"
              >
                <Sprout size={14} /> Owner Studio
              </Link>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
